import { useWorkspace } from '@/hooks/useWorkspace';
import { ChevronsUpDown, Check, Plus } from 'lucide-react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SidebarMenuButton } from '@/components/ui/sidebar';
import { useSidebar } from '@/components/ui/sidebar';

export function WorkspaceSwitcher() {
    const { workspaces, currentWorkspace, switchWorkspace } = useWorkspace();
    const { isMobile } = useSidebar();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <SidebarMenuButton
                    size="lg"
                    className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
                >
                    <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
                        <span className="font-bold text-lg">
                            {currentWorkspace?.name.charAt(0).toUpperCase()}
                        </span>
                    </div>
                    <div className="grid flex-1 text-left text-sm leading-tight min-w-0">
                        {/* M2 (audit): wrap long workspace names instead of one-line truncating to "AUTOMATION_SECURE'…". */}
                        <span className="break-words font-semibold uppercase tracking-tighter">
                            {currentWorkspace?.name || 'Select Workspace'}
                        </span>
                        <span className="truncate text-xs text-muted-foreground">
                            {workspaces.length > 1 ? 'Switch Workspace' : 'Free Plan'}
                        </span>
                    </div>
                    <ChevronsUpDown className="ml-auto size-4" />
                </SidebarMenuButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
                align="start"
                side={isMobile ? "bottom" : "right"}
                sideOffset={4}
            >
                <DropdownMenuLabel className="text-xs text-muted-foreground">
                    Workspaces
                </DropdownMenuLabel>
                {workspaces.map((workspace) => (
                    <DropdownMenuItem
                        key={workspace.id}
                        onClick={() => switchWorkspace(workspace.id)}
                        className="gap-2 p-2"
                    >
                        <div className="flex size-6 items-center justify-center rounded-sm border">
                            {workspace.name.charAt(0).toUpperCase()}
                        </div>
                        {workspace.name}
                        {currentWorkspace?.id === workspace.id && (
                            <Check className="ml-auto size-4" />
                        )}
                    </DropdownMenuItem>
                ))}
                <DropdownMenuSeparator />
                <DropdownMenuItem className="gap-2 p-2" disabled>
                    <div className="flex size-6 items-center justify-center rounded-md border bg-background">
                        <Plus className="size-4" />
                    </div>
                    <div className="font-medium text-muted-foreground">Create Workspace</div>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
